import React, { useState, useEffect, useContext } from 'react'
import ScrollToTop from '../../ScrollToTop'
import { RapperContent } from '../../../App'
const Profile = () => {
    const { loginsuccess, setLoginsuccess } = useContext(RapperContent)
    useEffect(() => {
        if (!loginsuccess) {
            window.location.href = '/'
        }
    })
    let content;
    const dashboard = <>
        <p className="text-blk-ash text-sm">From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.</p>
    </>
    const orders = <>
        <p>This is Orders</p>
    </>
    const download = <>
        This is download </>
    const address = <>
        This is address </>
    const accountDetails = <>
        account Detialse
    </>

    const [pageRequest, setPageRequest] = useState('dashboard')

    if (pageRequest === 'dashboard') {
        content = dashboard;
    }
    else if (pageRequest === 'orders') {
        content = orders;
    }
    else if (pageRequest === 'address') {
        content = address;
    }
    else if (pageRequest === 'download') {
        content = download;
    }
    else {
        content = accountDetails
    }
    // log out action
    const logout = () => {
        localStorage.removeItem('user')
        setLoginsuccess(false)
    }

    return (
        <div>
            <ScrollToTop />
            <div className="w-full h-40 flex justify-center items-center" style={{ background: '#f6f6f6' }}>
                <h1 className="text-4xl text-blk-txt">My Profile</h1>
            </div>
            <div className="w-full py-10 px-5 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3">
                <div className="w-full">
                    <ul>
                        <li onClick={() => setPageRequest('dashboard')} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Dashboard</li>
                        <li onClick={() => setPageRequest('orders')} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Orders</li>
                        <li onClick={() => setPageRequest('download')} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Downloads</li>
                        <li onClick={() => setPageRequest('address')} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Addresses</li>
                        <li onClick={() => setPageRequest('accountDetails')} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Account Details</li>
                        <li onClick={logout} className='border-b border-border-clr p-3 text-sm text-blk-ash cursor-pointer hover:text-primary-txt'>Sign Out</li>
                    </ul>
                </div>
                <div className="col-span-1 md:col-span-2 lg:col-span-2 px-4 py-4">
                    {content}
                </div>
            </div>
        </div>
    )
}

export default Profile
